var render = function render(){var _vm=this,_c=_vm._self._c;return _c('geko-base-crud',{attrs:{"config":_vm.config,"hideUpdate":true},scopedSlots:_vm._u([{key:"list-tree_id",fn:function({ item }){return [_c('div',{staticClass:"d-flex flex-column"},[_c('p',{staticClass:"mb-0"},[_c('span',[_vm._v(_vm._s(item.trees_tree_name)+" "),(
              item.trees_common_name &&
              item.trees_common_name.toLowerCase() !==
                item.trees_tree_name.toLowerCase()
            )?_c('span',{staticClass:"font-weight-300"},[_vm._v("("+_vm._s(item.trees_common_name)+")")]):_vm._e()])]),_c('div',{staticClass:"d-flex flex-row"},[_c('div',{staticClass:"badge bg-light"},[_vm._v(_vm._s(item.tree_code))])])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }